import React, { useEffect, useState } from "react"
import { Button, Header, Icon, Modal } from "semantic-ui-react"
import { AdminParcelEventType } from "../../getParcelActions"
import { AdminParcelEventReason } from "types/parcel.types"
import { ReturnModalContent } from "./ReturnToPlanModal.styled"
import { SectionTitle } from "../ReturnRequestModal/RequestReturnModal.styled"
import Select from "components/Form/Select"
import { getReturningCarrierNameList } from "../ReturnRequestModal/data"
import { Company } from "types/company.types"
import { CarriersName } from "types/carrier.types"

interface ReturnToPlanModalProps {
  isOpened: boolean
  adminEvent: {
    opened: boolean
    type: AdminParcelEventType
    reason: { value: string; label: string }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any
  }
  changeAdminEventData: (key: string, value: string | object) => void
  collectionCarriers: Company[]
  openReturnToPlanModal: (type: AdminParcelEventType) => void
  cancelReturnToPlanModal: () => void
  submitAdminEvent: (reason?: AdminParcelEventReason) => Promise<void>
}

export const ReturnToPlanModal = ({
  isOpened,
  adminEvent,
  changeAdminEventData,
  collectionCarriers,
  openReturnToPlanModal,
  cancelReturnToPlanModal,
  submitAdminEvent,
}: ReturnToPlanModalProps) => {
  const [returningCarrierOptions, setReturningCarrierOptions] = useState<
    { value: string; label: string; data: Company }[]
  >([])

  // Always reset the returning carrier options at each modal opening
  useEffect(() => {
    if (isOpened) {
      // For RETURN TO PLAN, we don't want to show La Poste and Relais Colis as returning carriers => return must be requested directly
      const options = getReturningCarrierNameList(collectionCarriers, [
        CarriersName.POST_OFFICE,
        CarriersName.RELAISCOLIS,
      ])

      setReturningCarrierOptions(options)

      // Auto set the returning carrier if there is only one
      if (options.length === 1) {
        changeAdminEventData("returningCarrier", options[0])
      }
    }
  }, [isOpened, collectionCarriers])

  return (
    <Modal
      onClose={cancelReturnToPlanModal}
      onOpen={() => openReturnToPlanModal(AdminParcelEventType.RETURN_TO_PLAN)}
      open={isOpened}
    >
      <Header>En êtes vous sûr?</Header>
      <Modal.Content>
        <SectionTitle>🚚 Configuration du retour</SectionTitle>
        <Select
          value={adminEvent.data.returningCarrier}
          onChange={carrier => changeAdminEventData("returningCarrier", carrier)}
          options={returningCarrierOptions}
          placeholder="Quel transporteur de retour ?"
          isDisabled={false}
        />
        <ReturnModalContent>
          Nous enverrons une notification push et retournerons le questionnaire au keeper si vous confirmez.
        </ReturnModalContent>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={cancelReturnToPlanModal}>
          <Icon name="remove" /> Annuler
        </Button>
        <Button
          color="green"
          onClick={async () => {
            await submitAdminEvent()
          }}
          disabled={!adminEvent.data.returningCarrier}
        >
          <Icon name="checkmark" /> Confirmer
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
